import i18next from 'i18next';

/**
 * Patient enum tables — lifted whole from
 * `_legacy/components/Patients/constants.js` so the legacy file can be
 * deleted. Values are unchanged; the backend contract for race/language
 * is preserved.
 */
export const GENDER_ITEMS = [
  { label: i18next.t('forms:female'), value: 'female' },
  { label: i18next.t('forms:male'), value: 'male' },
];

export const PATIENT_LANGUAGE = {
  ENGLISH: 'english',
  SPANISH: 'spanish',
  UNKNOWN: 'unknown',
};

export const PATIENT_LANGUAGE_BY_KEY = {
  [PATIENT_LANGUAGE.ENGLISH]: 'English',
  [PATIENT_LANGUAGE.SPANISH]: 'Spanish',
  [PATIENT_LANGUAGE.UNKNOWN]: 'Unknown',
};

export const PATIENT_LANGUAGE_SELECTOR_OPTIONS = [
  { label: 'English', value: PATIENT_LANGUAGE.ENGLISH },
  { label: 'Spanish', value: PATIENT_LANGUAGE.SPANISH },
  { label: 'Unknown', value: PATIENT_LANGUAGE.UNKNOWN },
];

export const PATIENT_ENGAGEMENT_STATUSES = {
  enabled: 'enabled',
  disabled: 'disabled',
};

export const PATIENT_ENGAGEMENT_STATUS_OPTIONS = [
  {
    label: i18next.t('forms:patientEngagementEnabledShort'),
    value: PATIENT_ENGAGEMENT_STATUSES.enabled,
  },
  {
    label: i18next.t('forms:patientEngagementDisabledShort'),
    value: PATIENT_ENGAGEMENT_STATUSES.disabled,
  },
];

export const PATIENT_RACE = {
  NON_HISPANIC_WHITE: 'Non-Hispanic White / Caucasian',
  HISPANIC_LATINO: 'Hispanic / Latino',
  AFRICAN_AMERICAN_BLACK: 'African American Black',
  ASIAN: 'Asian',
  AMERICAN_INDIAN_ALASKA_NATIVE: 'American Indian or Alaska Native',
  NATIVE_HAWAIIAN_PACIFIC_ISLANDER: 'Native Hawaiian or Other Pacific Islander',
  MIDDLE_EASTERN_NORTH_AFRICAN: 'Middle Eastern or North African',
  MULTIRACIAL_OTHER: 'Multiracial or none of the above',
};

export const PATIENT_RACE_BY_KEY = { ...PATIENT_RACE };

// i18n keys (patientOptions namespace) for the selector labels. Values
// stay the backend contract; only the display label is localized, with
// the raw value as the fallback label.
export const PATIENT_LANGUAGE_TRANSLATION_KEYS = {
  [PATIENT_LANGUAGE.ENGLISH]: 'languageEnglish',
  [PATIENT_LANGUAGE.SPANISH]: 'languageSpanish',
  [PATIENT_LANGUAGE.UNKNOWN]: 'languageUnknown',
};

export const PATIENT_RACE_TRANSLATION_KEYS = {
  [PATIENT_RACE.NON_HISPANIC_WHITE]: 'raceNonHispanicWhite',
  [PATIENT_RACE.HISPANIC_LATINO]: 'raceHispanicLatino',
  [PATIENT_RACE.AFRICAN_AMERICAN_BLACK]: 'raceAfricanAmericanBlack',
  [PATIENT_RACE.ASIAN]: 'raceAsian',
  [PATIENT_RACE.AMERICAN_INDIAN_ALASKA_NATIVE]: 'raceAmericanIndianAlaskaNative',
  [PATIENT_RACE.NATIVE_HAWAIIAN_PACIFIC_ISLANDER]: 'raceNativeHawaiianPacificIslander',
  [PATIENT_RACE.MIDDLE_EASTERN_NORTH_AFRICAN]: 'raceMiddleEasternNorthAfrican',
  [PATIENT_RACE.MULTIRACIAL_OTHER]: 'raceMultiracialOther',
};

export const PATIENT_RACE_SELECTOR_OPTIONS = Object.values(PATIENT_RACE).map(value => ({
  label: value,
  value,
}));
